export function Logo({ className = "size-8" }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Zworks"
    >
      <title>Zworks</title>
      <path d="M 6 7 H 26 L 14 19 H 6 Z" fill="currentColor" />
      <path d="M 18 13 L 26 13 L 26 25 H 6 Z" fill="currentColor" />
      <rect x="23" y="5" width="4" height="4" rx="1" fill="#6366F1" />
      <rect x="5" y="23" width="4" height="4" rx="1" fill="#6366F1" />
    </svg>
  );
}